// HighlightedText.tsx - Create this as a new component file

import React from 'react';

interface HighlightedTextProps {
    text: string;
    searchTerms: string[];
    className?: string;
}

const HighlightedText: React.FC<HighlightedTextProps> = ({ text, searchTerms, className }) => {
    // If no search terms or empty text, return original text
    if (!searchTerms.length || !text) {
        return <span className={className}>{text}</span>;
    }

    // Filter out empty search terms and create regex pattern
    const validSearchTerms = searchTerms.filter(term => term.trim().length > 0);
    if (validSearchTerms.length === 0) {
        return <span className={className}>{text}</span>;
    }

    // Escape special regex characters in search terms
    const escapeRegex = (string: string) => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    // Create a regex pattern that matches any of the search terms (case insensitive)
    const pattern = validSearchTerms
        .map(term => escapeRegex(term.trim()))
        .join('|');
    
    const regex = new RegExp(`(${pattern})`, 'gi');

    // Split the text by the search terms while keeping the delimiters
    const parts = text.split(regex);

    return (
        <span className={className}>
            {parts.map((part, index) => {
                // Check if this part matches any search term (case insensitive)
                const isMatch = validSearchTerms.some(term => 
                    part.toLowerCase() === term.toLowerCase()
                );

                return isMatch ? (
                    <mark 
                        key={index} 
                        style={{ 
                            backgroundColor: '#fff3cd', 
                            fontWeight: 'bold',
                            padding: '1px 2px',
                            borderRadius: '2px'
                        }}
                    >
                        {part}
                    </mark>
                ) : (
                    <span key={index}>{part}</span>
                );
            })}
        </span>
    );
};

export default HighlightedText;